<template>
  <div>
    <!-- 置顶 -->
    <div class="toTop" @click="toTop"></div>
  </div>
</template>

<script>
export default {
  name: "toTopKaiqi",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // 监听置顶
    $(window).scroll(function(){
        if($(window).scrollTop()>$(window).height()){
            $(".toTop").fadeIn();
        }else{
            $(".toTop").fadeOut();
        }
    })
  },
  methods: {
    // 置顶
    toTop(){
      $('body,html').animate({ scrollTop: 0 }, 500);
    }
  },
};
</script>

<style lang='less' scoped>
    //置顶按钮
    .toTop{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color:@expertFontColor255;
        background-image: url(~@assets/images/icon/toTopNew.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 40px;
        position: fixed;
        bottom: 104px;
        right: 12px;
        z-index: 97;
        font-size:@indexFontSize20;
        text-align: center;
        display: none;
    }
</style>
